
import * as R from 'ramda'
import { call, reducer } from '../../../helpers/api/meta'
import { getCourseFAQsList } from '../../../helpers/api/api';

export const GET_COURSE_FAQS = 'GET_COURSE_FAQS'

export const callGetCourseFAQsList = (inputs) => {
    const meta = {
        endpoint: (params) => getCourseFAQsList(params),
        inputs,
        action: GET_COURSE_FAQS,
        messages: {
            id: 'getCourseFAQsList',
            failure: 'Could not get course FAQs'
        }
    }
    return call(meta)
}

const initialState = {
    loading: false,
    results: []
}

const saveCourseFAQs = (state, action) => {
    return R.assoc('results', action.results, state);
}

const messages = {
    loadFailed: 'Could not load FAQs.',
}

export default reducer(initialState, GET_COURSE_FAQS, saveCourseFAQs, messages.loadFailed)